<script setup lang="ts">
import type { Order } from "@/model/backend/order"
import GematikAppBadges from "./GematikAppBadges.vue"
import CopyInputField from "./prescription/CopyInputField.vue"
import PharmacyAddress from "./prescription/PharmacyAddress.vue"

defineProps<{ order: Order }>()
</script>

<template>
    <div class="alert alert-primary mt-3 d-flex align-items-center">
        <div>
            <i class="fa fa-fw fa-exclamation fa-3x mr-3"></i>
        </div>
        <div v-if="order.prescriptionTransmission == 'paper/in-person'">
            <b>Bitte bring dein Rezept persönlich bei uns vorbei:</b>
            <PharmacyAddress />
        </div>
        <div v-else-if="order.prescriptionTransmission == 'paper/letter-doctor'">
            <b>Bitte informiere deinen Arzt, dass er dein Rezept direkt per Post an uns verschickt.</b>

            <PharmacyAddress />
        </div>
        <div v-else-if="order.prescriptionTransmission == 'digital/token'">
            <b>Bitte lade dein E-Rezept-Token in deinem Profil unter Bestellungen hoch.</b>
        </div>
        <div v-else-if="order.prescriptionTransmission == 'digital/kim'">
            <b>Bitte informiere deinen Arzt, dass er uns dein Rezept an die folgende KIM-Adresse sendet:</b>

            <CopyInputField value="inselpark.hamburg@gedisa.kim.telematik" />
        </div>
        <div v-else-if="order.prescriptionTransmission === 'digital/app'">
            <b class="mb-3 d-block">
                Bitte schick uns dein Rezept über die Gematik App. Wähle dazu in der App die „apotheke am inselpark“ aus
                und folge den Anweisungen.
            </b>

            <GematikAppBadges />
        </div>
        <div v-else-if="order.prescriptionTransmission == 'digital/health-card'">
            <b> Bitte komm bei uns vorbei, dass wir dein E-Rezept über deine Gesundheitskarte auslesen können. </b>

            <PharmacyAddress />
        </div>
        <div
            v-else-if="
                order.prescriptionTransmission == 'email/link' || order.prescriptionTransmission == 'email/encrypted'
            "
        >
            <b>Bitte teile dem Arzt oder telemedizinischen Anbieter unsere E-Mailadresse mit.</b>

            <CopyInputField value="info@cann24.de" />
        </div>
        <div v-else>
            <b>Bitte sende das Originalrezept an folgende Adresse:</b>

            <PharmacyAddress />
        </div>
    </div>
</template>
